import * as React from 'react';
import * as types from '../../types';
import * as services from '../../services';
import { SelectionMode } from '@fluentui/react/lib/DetailsList';
import { ColumnType, IGenColumn } from '../../types/GenColumn';
import EntityListCat from '../entity/EntityListCat';
import { renderDate, renderDateRange, renderDateWithTime } from '../cr/ListRenderers';
import { DateService } from '../../services';


interface ILookupData {
}
class LookupData implements ILookupData {
}

export interface ILogsClsProps extends types.IBaseComponentProps {
}

interface IAppSettingsState {
}

class AppSettingsState implements IAppSettingsState {
  constructor() {
  }
}

export default class LogsCls extends React.Component<ILogsClsProps, AppSettingsState> {
  constructor(props: ILogsClsProps, state: IAppSettingsState) {
    super(props);
    this.state = new AppSettingsState();
  }

  public render(): React.ReactElement<ILogsClsProps> {
    return (
      <React.Fragment>
        {this.renderLogsList()}
      </React.Fragment>
    );
  }

  private renderLogsList() {

    const listColumns: IGenColumn[] = [
      {
        key: 'Module',
        columnType: ColumnType.TextBox,
        name: 'Category',
        fieldName: 'Module',
        minWidth: 85,
        maxWidth: 100,
        isMultiline: true,
        isResizable: true,
        isRequired: true,
        fieldMaxLength: 50
      },
      {
        key: 'Title',
        columnType: ColumnType.TextBox,
        name: 'Title',
        fieldName: 'Title',
        minWidth: 120,
        maxWidth: 160,
        isMultiline: true,
        isResizable: true,
        isRequired: true,
        fieldMaxLength: 50,
        isCollapsible: true
      },

      {
        key: 'UserTitle',
        columnType: ColumnType.TagPickerForUser,
        name: 'Display Name',
        fieldName: 'UserTitle',
        idFieldName: 'UserId',
        isParent: true,
        parentEntityName: 'User',
        parentColumnName: 'Title',
        parentService: new services.UserService(),
        minWidth: 100,
        maxWidth: 100,
        isMultiline: true,
        isResizable: true,
        isRequired: true
      },
      {
        key: 'LogDate',
        columnType: ColumnType.TextBox,
        name: 'Date',
        fieldName: 'LogDate',
        minWidth: 70,
        maxWidth: 100,
        isMultiline: true,
        isResizable: true,
        isRequired: true,
        fieldMaxLength: 50,
        onRender: item => DateService.toDisplayDateTime(item.LogDate)
      },
      {
        key: 'Details',
        columnType: ColumnType.TextBox,
        name: 'Details',
        fieldName: 'Details',
        minWidth: 160,
        maxWidth: 300,
        isResizable: true,
        isMultiline: true,
        isRequired: true,
        fieldMaxLength: 5000,
        numRows: 5,
        isCollapsible: true,
      },
      {
        key: 'IPAddress',
        columnType: ColumnType.TextBox,
        name: 'IP Address',
        fieldName: 'IPAddress',
        minWidth: 100,
        maxWidth: 120,
        isResizable: true,
        isCollapsible: true,
        onRender: (item: any) => {
          const ipRaw = item?.IPAddress;
          const ip = ipRaw?.trim();

          if (!ip || ip.toLowerCase() === "null") return null;

          const url = `https://ipinfo.io/${ip}`;

          return (
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#0078d4', textDecoration: 'underline' }}
            >
              {ip}
            </a>
          );
        }



      }

    ];

    return (
      <React.Fragment>
        <EntityListCat
          selectionMode={SelectionMode.none}
          pageSize={100}
          allowAdd={false}
          columns={listColumns}
          entityReadAllExpandAll={true}
          {...this.props}
          errorHandling={this.props.errorHandling}
          entityService={new services.LogService()}
          entityNamePlural="Logs"
          entityNameSingular="Log"
          childEntityNameApi=""
          childEntityNamePlural=""
          childEntityNameSingular=""
        />
      </React.Fragment>
    );
  }

}
